import React from 'react';
import { Flex, Text, Image } from '@chakra-ui/react';
import RecommendedGameBox from './recommendedGameBox';

const FeaturedRecommendedGames = ({ smallerImage }: { smallerImage: string }) => {
	return (
		<Flex
			w="100%"
			flexDirection="column"
			gridGap="16px"
		>
			<Flex
				justifyContent="space-between"
				w="100%"
				alignItems="center"
			>
				<Text
					textTransform="uppercase"
					fontWeight="600"
					fontSize="10px"
					letterSpacing="0.1em"
				>
					Featured and recommended
				</Text>
				<Flex gridGap="8px">
					<Image src="/assets/icons/circle-chevron-left.png" />
					<Image src="/assets/icons/circle-chevron-right.png" />
				</Flex>
			</Flex>
			<Flex
				w="100%"
				gridGap="20px"
			>
				<RecommendedGameBox
					image={smallerImage}
					title="Lumencraft"
					game
				/>
				<RecommendedGameBox title="Toast it" />
				<RecommendedGameBox title="Portal Car" />
				<RecommendedGameBox title="#2048" />
				<RecommendedGameBox title="Run Grandpa Run" />
			</Flex>
		</Flex>
	);
};

export default FeaturedRecommendedGames;
